import { Pagination } from '@mui/material';
import { FC, useRef } from 'react';
import PaginationItemPublicDecisions from './PaginationItemPublicDecisions';

interface PaginationPublicDecisionsPageProps {
    page: number;
    totalPages: number;
    year: string;
}

const PaginationPublicDecisions: FC<PaginationPublicDecisionsPageProps> = ({
    page,
    totalPages,
    year,
}) => {
    const ellipsisShownRef = useRef(false);
    const countTensRef = useRef(0);

    return (
        <Pagination
            count={totalPages}
            hideNextButton={page === totalPages}
            hidePrevButton={page === 1}
            page={page}
            renderItem={(item) => (
                <PaginationItemPublicDecisions
                    countTensRef={countTensRef}
                    currentPage={page}
                    ellipsisShownRef={ellipsisShownRef}
                    item={item}
                    totalPages={totalPages}
                    year={year}
                />
            )}
            shape="rounded"
            siblingCount={totalPages}
            variant="outlined"
        />
    );
};

export default PaginationPublicDecisions;
